"use strict";

/**
 * @classdesc
 * Abstrakte Wrapperklasse für eine Geometrie-Collection.
 *
 * @class
 * @abstract
 * @extends gc.gis.geom.GCGeometry
 * @memberof gc.gis.geom
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {T} collection gewrappte Geometrie-Collection-Instanz
 */
gc.gis.geom.GCGeometryCollection = function(collection)
{
    gc.gis.geom.GCGeometry.call(this, collection);

	/**
     * Liste der gewrappten Geometrien
	 * @type {gc.gis.geom.GCGeometry[]}
	 */
	this._geometries = [];
};
gc.gis.geom.GCGeometryCollection.prototype = Object.create(gc.gis.geom.GCGeometry.prototype);


/**
 * Gibt die Anzahl der Geometrien der Collection zurück.
 *
 * @method
 * @return {int} Anzahl der Geometrien
 * @public
 */
gc.gis.geom.GCGeometryCollection.prototype.numGeometries = function ()
{
    return this._geometries.length;
};

/**
 * Gibt die Geometrien der Collection zurück.
 *
 * @method
 * @return {gc.gis.geom.GCGeometry[]} Liste von Geometrien
 * @public
 */
gc.gis.geom.GCGeometryCollection.prototype.getGeometries = function ()
{
    return this._geometries;
};

/**
 * Gibt eine Geometrie der Collection zurück.
 *
 * @method
 * @param {int} index
 * @return {gc.gis.geom.GCGeometry} Geometrien
 * @public
 */
gc.gis.geom.GCGeometryCollection.prototype.getGeometry = function (index)
{
    if (index >= 0 && index < this._geometries.length)
    {
        return this._geometries[index];
    }

    throw new gc.gis.error.GCError('Geometry index [' + index + '] out of bounds.');
};

/**
 * Setzt die Liste von Geometrien der Collection.
 *
 * @method
 * @param {gc.gis.geom.GCGeometry[]} geometries Liste von Geometrien
 * @return {gc.gis.geom.GCGeometryCollection}
 * @public
 */
gc.gis.geom.GCGeometryCollection.prototype.setGeometries = function (geometries)
{
    this._geometries = geometries;

    this._resetGeometryImpl();
    for (var i = 0; i < this._geometries.length; i++)
    {
        this._addGeometryImpl(this._geometries[i].getImpl());
    }

    return this;
};

/**
 * Fügt eine Geometrie der Collection hinzu.
 *
 * @method
 * @param {gc.gis.geom.GCGeometry} geometry Geometrie
 * @return {gc.gis.geom.GCGeometryCollection}
 * @public
 */
gc.gis.geom.GCGeometryCollection.prototype.addGeometry = function(geometry)
{
    this._geometries.push(geometry);
    this._addGeometryImpl(geometry.getImpl());

    return this;
};

/**
 * Fügt eine Geometrie der gewrappten Collection hinzu.
 *
 * @method
 * @param {T} geometry gewrappte Geometrie-Collection-Instanz
 * @protected
 */
gc.gis.geom.GCGeometryCollection.prototype._addGeometryImpl  = gc.gis.abstractMethod;

/**
 * Leert die gewrappte Collection.
 *
 * @method
 * @protected
 */
gc.gis.geom.GCGeometryCollection.prototype._resetGeometryImpl  = gc.gis.abstractMethod;